module.exports = {
  STATEMENT_XLSX: 'STATEMENT_XLSX',
  STATEMENT_XLSX_V2: 'STATEMENT_XLSX_V2',
  STATEMENT_CSV: 'STATEMENT_CSV',
  STATEMENT_PDF: 'STATEMENT_PDF',
  STATEMENT_OFX: 'STATEMENT_OFX',
  BILLING: 'BILLING',
  PAYIN_CSV: 'PAYIN_CSV'
};
